module.exports = __webpack_public_path__ + "static/Patient-registration-form-3116d1d966b3c3a2f1790cf4de052f79.pdf";